import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { HttpClientService, UtilityService } from 'lib/ng2-sapmp/src/providers';

@Injectable()
export class DashboardService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private utilityService: UtilityService) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  getFanStatusSummary(companyId) {
    // will be calling actual api with company id;
    let apiUrl;
    if (this.utilityService.getEnvConfig().useMock) {
      apiUrl = this.utilityService.getEnvConfig().getFanStatusSummarymock[companyId];
    } else {
       apiUrl = this.utilityService.getEnvConfig().dashboardSummary;
    }
    return this.httpClientService.get(apiUrl, this.get_headers())
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  getDeviceStatusSummary(url, req) {
    // will be calling actual api with request;
    return this.httpClientService.get(url, this.get_headers())
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  getDashboardContent(url) {
    // will be calling actual api with request;
    return this.httpClientService.get(url)
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  getAppleCertificateSummary(url, companyId) {
    // will be calling actual api with companyId;
    return this.httpClientService.get(url)
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  handleError(error) {
    return throwError(error);
  }

}
